import { createAction, props } from '@ngrx/store'
import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const AutomationWizardSaveAction = createAction(
  '[Automations Wizard] Save Action',
  props<{ closeAfterSave: boolean }>()
)

export const AutomationWizardChangeEventAction = createAction(
  '[Automations Wizard] Change Event Action',
  props<{ event: AutomationEventTypes }>()
)

export const AutomationWizardCloseAction = createAction('[Automations Wizard] Close Action')

export const AutomationWizardNextAction = createAction('[Automations Wizard] Next Action')
export const AutomationWizardPrevAction = createAction('[Automations Wizard] Prev Action')
